import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class ZeroHashSubdivision {
  value = ""
  label = ""
}

export const ZERO_HASH_SUBDIVISION_DESER: SchemaDeSer<ZeroHashSubdivision> =
  new SchemaDeSerBuilder(ZeroHashSubdivision)
    .ofString("value", "code")
    .ofString("label", "name")
    .toDeSer()
